import React from 'react';
import DgModal from "../../../../../custom/feedback/modal";
import {useTranslation} from "react-i18next";
import DgForm from "../../../../../custom/data-entry/form";
import {Form, Input} from "antd";
import {getMe} from "../../../../../api/system/admin/user-account";
import {changePassword} from "../../../../../api/account";

const ChangePassword = props => {

    const {t} = useTranslation()
    const [form] = Form.useForm()
    const me = getMe();

    const handleOnFinish = (value) => {
        changePassword(me.accountId, value).then(r =>{
            props.onCancel()
        })
            .catch(()=>{})

    }

    return (
        <>
            <DgModal
                title={t("layout.changePassword")}
                visible={props.visible}
                onCancel={props.onCancel}
                width={600}
                okText={"Cập nhật"}
            >

                <DgForm
                    form={form}
                    mode={"update"}
                    onFinish={handleOnFinish}
                    autoComplete="on"
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                    colon={false}
                    labelAlign="left"
                    scrollToFirstError={true}
                >
                    <Form.Item
                        name={"password"}
                        label={"Mật khẩu hiện tại"}
                    >
                        <div className={"customer_input_password"}>
                            <Input.Password placeholder={"Mật khẩu hiện tại"}/>
                        </div>
                    </Form.Item>

                    <Form.Item
                        name={"newPassword"}
                        label={"Mật khẩu mới"}
                    >
                        <div className={"customer_input_password"}>
                            <Input.Password placeholder={"Mật khẩu mới"}/>
                        </div>
                    </Form.Item>

                    <Form.Item
                        name={"confirmPassword"}
                        label={"Xác nhận mật khẩu mới"}
                    >
                        <div className={"customer_input_password"}>
                            <Input.Password placeholder={"Mật khẩu mới"}/>
                        </div>
                    </Form.Item>
                </DgForm>
            </DgModal>

        </>
    );
};

ChangePassword.propTypes = {};

export default ChangePassword;
